module.exports = __webpack_public_path__ + "img/wait_input_then_idle_icon.0c9da211.svg";